import { Button, HStack, Text, VStack, Wrap, WrapItem } from '@chakra-ui/react';
import type { SearchFilterFacetOption } from './searchFilterCategories';

type Props = {
  title: string;
  options: SearchFilterFacetOption[];
  selectedValues: string[];
  onToggleValue: (value: string) => void;
  onResetOrApplyAll: () => void;
};

export const SearchFilterCategorySection = ({
  title,
  options,
  selectedValues,
  onToggleValue,
  onResetOrApplyAll,
}: Props): JSX.Element => {
  const isResetAll = selectedValues.length !== 0;

  return (
    <VStack align="stretch" gap="3" width="100%">
      <HStack justify="space-between">
        <Text textStyle="body.s.semibold" color="text.primary">
          {title}
        </Text>
        <Button variant="tertiary" size="m" onClick={onResetOrApplyAll}>
          {isResetAll ? 'Alle löschen' : 'Alle auswählen'}
        </Button>
      </HStack>
      <Wrap gap="8px">
        {options.map((option) => {
          const isSelected = selectedValues.includes(option.value);
          return (
            <WrapItem key={option.value}>
              <Button
                variant="secondary"
                size="m"
                borderColor={isSelected ? 'border.accent.active' : undefined}
                bg={isSelected ? 'background.subtle.green' : undefined}
                aria-pressed={isSelected}
                onClick={() => onToggleValue(option.value)}
                _focusVisible={{
                  outline: 'none',
                }}
                _focusWithin={{
                  outline: 'none',
                }}
                _hover={
                  isSelected
                    ? {
                        borderColor: 'border.accent.active',
                      }
                    : undefined
                }
              >
                {option.label}
              </Button>
            </WrapItem>
          );
        })}
      </Wrap>
    </VStack>
  );
};
